import { ChangeDetectionStrategy, Component, HostBinding, Input, OnInit, ViewEncapsulation } from "@angular/core";
import { select, Store } from "@ngrx/store";
import { AamsGameDataContextState } from "@obg/gaming.aams-game-data";
import { CoreContentState, Icon, IconSelector } from "@obg/ngx.core.content";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { RegulatoryBarService } from "../../regulatory-bar.service";
import { AAMS_GAME_REGULATORY_BAR_HEIGHT, AAMS_REGULATORY_BAR } from "../aams-regulatory-bar.container.const";

@Component({
	selector: "obg-aams-game-regulatory-bar",
	templateUrl: "./aams-game-regulatory-bar.container.html",
	styleUrls: ["./aams-game-regulatory-bar.container.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class AamsGameRegulatoryBarContainer implements OnInit {
	@HostBinding("class.obg-aams-game-regulatory-bar") hostCssClass = true;

	@Input() aamsGameData: AamsGameDataContextState | undefined;

	regulationIcons$: Observable<Icon[]> | undefined;

	constructor(
		private store: Store<CoreContentState>,
		private iconSelector: IconSelector,
		private regulatoryBarService: RegulatoryBarService
	) {}

	ngOnInit() {
		this.regulatoryBarService.setRegulatoryBarDynamicHeight(AAMS_GAME_REGULATORY_BAR_HEIGHT);

		this.regulationIcons$ = this.store.pipe(
			select(this.iconSelector.get(AAMS_REGULATORY_BAR.ICON_NAME)),
			map((icons) => icons.slice(-2))
		);
	}
}
